import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { SabisNgxNotificationService, SabisTranslateService } from 'sabis-components2';
import { AppLoaderService } from './@theme/shared/services/app-loader/app-loader.service';
import { RoutePartsService } from './@theme/shared/services/route-parts.service';
import { UILibIconService } from './@theme/shared/services/ui-lib-icon.service';
import { AppAuthService } from './core/auth/app-auth.service';
import { AppCookiesComponent } from './shared/app-cookies/app-cookies.component';
import { LoadingIndicatorComponent } from './@theme/shared/services/loading-indicator/loading-indicator.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterModule,
    AppCookiesComponent,
    LoadingIndicatorComponent
  ]
})
export class AppComponent implements OnInit {
  public appTitle = 'SABIS® Careers';
  public pageTitle = '';
  public isAuthenticating = true;

  public isLoading: boolean = false;
  public isLoadingInternal: boolean = false;

  @ViewChild('cookies', { static: true }) cookies!: AppCookiesComponent;

  constructor(public authService: AppAuthService,
    public title: Title,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private routePartsService: RoutePartsService,
    public appLoader: AppLoaderService,

    private _notifications: SabisNgxNotificationService,

    private _translation: SabisTranslateService,
    private iconService: UILibIconService
  ) {
    iconService.init();
    this._notifications.initialize();

    // Check cookies on each page
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.cookies.manageCookiesBanner();
      }
    });
  }

  ngOnInit() {
    this.changePageTitle();
    this._translation.loadLanguage('en');
  }

  private changePageTitle() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((routeChange) => {
      const routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
      if (!routeParts.length) {
        return this.title.setTitle(this.appTitle);
      }
      // Extract title from parts;
      this.pageTitle = routeParts
        .reverse()
        .map((part) => part.title)
        .reduce((partA, partI) => { return `${partA} > ${partI}` });
      this.pageTitle += ` | ${this.appTitle}`;
      this.title.setTitle(this.pageTitle);
    });
  }
}


